<template>
  <div>








      <div class="" style="background-color: #f6f6f6" >
          <b-col md="12" class=" pt-2"   style="background-color: #f6f6f6">


              <b-row  v-if="issueMoreDetailShow">
                  <b-col  md="12" class="px-0 mx-0" v-if="issue.process">
                      <div class='steps mx-0' v-if="issue.process.steps" >
                          <div v-for="(step, stepIndex) in issue.process.steps" :key="stepIndex"  class='step' :class="stepStyle(step.id, issue.step_id)">{{step.title}}</div>
                      </div>
                      <hr>
                  </b-col>


                  <b-col md="8" class="text-sm ">
                      <!--   <div class="user-image" v-if="issue.public_user.public_profile">--><!--                                                      <img v-if="issue.public_user.public_profile.image"--><!--                                                           :src="'/'+issue.public_user.public_profile.image" style="height: 30px" :alt="issue.public_user.name+' '+issue.public_user.family" class="">&ensp;--><!--                                                  </div>-->
<!--                      <router-link :to="{path : 'profile/'+issue.public_user.id }" >-->
<!--                          <small class="float-right"> ایجاد شده توسط:-->
<!--                              <span>-->
<!--                                                     {{issue.public_user.name}}-->
<!--                                </span>-->
<!--                              &ensp;<i v-if="2==3" class="fas fa-check-circle text-color-blue"></i>-->
<!--                          </small>-->
<!--                          <br>-->
                          <span :title="'ایجاد شده توسط: '+ issue.public_user.name">
                              <small class="float-right">    کاربران تخصیص داده شده:
                                  <b-badge size="sm"  variant="success" class="m-1" v-for="(assignedUser, assignedUserIndex) in issue.assigned_users" :key="assignedUserIndex" >
                                        {{assignedUser.name}}
                                  </b-badge>
                              </small>
                          </span>
<!--                      </router-link>-->
                  </b-col>



                  <b-col md="4" class="text-left text-sm ">

                      <small title="افزودن پیوست"  data-toggle="modal"
                              :data-target="'#add-attachment-main-'+issue.id"
                              class="m-1" style="color: #9e9e9e;font-size: 22px">
                          <i class="fa fa-file"></i>
                      </small>
                      <small title="ویرایش"  data-toggle="modal"
                              :data-target="'#edit-issue-'+issue.id" @click="editIssueState = true"
                              class="m-1 mx-2" style=";font-size: 22px;color: #9e9e9e" >
                          <i class="fa fa-edit"></i>
                      </small>
                      <small title="حذف" class="m-1" style="color: #9e9e9e;font-size: 22px"  v-if="role == 'superadministrator' || issue.created_by ==  authUser.id"  @click="deleteIssue(issue.id)"  >
                          <i class="fa fa-trash"></i>
                      </small>
                    <small title="بستن (آرشیو)" class="m-1" style="color: #9e9e9e;font-size: 22px"  v-if="role == 'superadministrator' || issue.created_by ==  authUser.id"  @click="closeIssue(issue.id)"  >
                          <i class="fas fa-calendar-times"></i>
                      </small>
                  </b-col>




                  <editIssue :issue="issue" :editIssueState="editIssueState" >
                  </editIssue>


                  <!--                                      <b-col  md="2">-->
                  <!--                                          <b-badge  v-if="issue.board" pill variant="info" class="text-left p-1" style="float: left"-->
                  <!--                                                    :style="{backgroundColor: boardColor(issue.board.id)}">-->
                  <!--                                              {{issue.board.title}}-->
                  <!--                                          </b-badge>-->

                  <!--                                      </b-col>-->



                  <!--                                      <b-col  md="2">-->
                  <!--                                          <small class="text-color-blue text-left " style="float: left">-->

                  <!--                                              <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1">سرنخ/فرصت (Lead)</span>-->
                  <!--                                              <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1">ملاقات/جلسه/رویداد</span>-->
                  <!--                                              <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1">پیگیری (Ticket)</span>-->
                  <!--                                              <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1">ایراد (Bug)</span>-->
                  <!--                                              <span v-if="issue.type == 'task'" class="badge badge-success pt-1">فعالیت (Task)</span>-->
                  <!--                                              <span v-if="issue.type == 'epic'" class="badge badge-info pt-1">نسخه/فیچر (Epic)</span>-->
                  <!--                                              <span v-if="issue.type == 'story'" class="badge badge-info pt-1">لیست (Story)</span>-->


                  <!--                                          </small>-->


                  <!--                                      </b-col>-->

                  <!--                                      <b-col  md="2">-->
                  <!--                                          <b-badge v-if="issue.priority == 3"  pill class="text-left p-1 mr-2" style="background-color: #212121;border: 1px solid #880e4f;float: left">اولویت زیاد</b-badge>-->
                  <!--                                          <b-badge v-else-if="issue.priority == 2"   pill class="text-left p-1 mr-2" style="background-color: #757575;float: left">اولویت متوسط</b-badge>-->
                  <!--                                          <b-badge v-else-if="issue.priority == 1"  pill  class="text-left p-1 mr-2" style="background-color: #9e9e9e;float: left">اولویت کم</b-badge>-->






                  <!--                                      </b-col>-->


                  <!--                                      <b-col  md="4" class="text-left text-sm">-->
                  <!--                                          <small>-->
                  <!--                                              {{issue.created_at| moment("dddd, jD jMMMM  jYYYY") }} <i class="far fa-clock"></i>-->
                  <!--                                          </small>-->


                  <!--                                      </b-col>-->





              </b-row>



            <h4   class="mt-0 pt-0 "   v-if="issueMoreDetailShow && issue.title && issue.title != 'null' && issue.title != '0'"> <small>#{{issue.id}}#</small>  {{issue.title}}</h4>
              <!--                                        <pre style="font-family:IRANSans , sans-serif !important " v-html="issue.intro"></pre>-->
              <p  v-if="issueMoreDetailShow && issue.description && issue.description != '-'"  v-html="issue.description.replace(/(?:\r\n|\r|\n)/g, '<br>')" style="overflow: hidden; direction: rtl!important;text-align: right!important;"></p>
              <small  v-if="issueMoreDetailShow && issue.text && issue.text != 'null' && issue.text != '0'" v-on:click="showIssueText(issue.text, issueIndex)" style="color: #9e9e9e;cursor: pointer">نمایش ادامه...</small>

              <p v-if="issueMoreDetailShow && issue.tags">
                  <b-badge class="m-1"  v-for="(tag, tagIndex) in issue.tags" :key="'tag-'+tagIndex" variant="primary">{{tag.title}}</b-badge>
              </p>

              <!-- fields show -->
              <div  v-if="issueMoreDetailShow && returnIssueFields(issue.fields, issue.field_values, issue.type_object).length !== 0">


                <b-row class="py-3" style="background-color: #fff">
                  <b-col  md="3" sm="12" v-if="field.pivot.value"  v-for="(field, fieldIndex) in returnIssueFields(issue.fields, issue.field_values, issue.type_object)" :key="fieldIndex" >
                    <small v-if="field.type !== 'space'">{{field.title}}: </small><br>

                    <b v-if="field.type === 'option' || field.type === 'radio'" class="text-gray">
                      <span  v-for="(option, optionIndex) in JSON.parse(field.options)" :key="optionIndex" v-if="option.value == field.pivot.value" >
                        {{option.title}}
                      </span>
                    </b>

                    <b v-else-if="field.type === 'check-box' || field.type === 'option-true-false'" class="text-gray">
                        <span class="text-success" v-if="field.pivot.value == '1'" > <i class="fas fa-check"></i> تأیید </span>
                        <span class="text-danger"  v-else-if="field.pivot.value == '0'"> <i class="fas fa-times"></i>  عدم تأیید </span>
                        <span v-else>نامشخص </span>
                    </b>

                    <br v-else-if="field.type === 'space'">

                    <b v-else class="text-gray">{{field.pivot.value}}</b>
                  </b-col>
                </b-row>

              </div>
            <div v-if="issue.type_object">
              <div v-if="issue.contact && issue.type_object.type == 9" class="card m-3 p-3">
<!--                <router-link v-if="issue.contact" :to="{path: '/contact/profile/'+issue.contact.id, params: {id:issue.contact.id}}"-->
<!--                             class="btn btn-sm btn-pill btn-dark mb-3">  پروفایل-->
<!--                </router-link>-->
                <b-table-simple hover small responsive>
                  <b-thead head-variant="default">
                    <b-tr>
                      <b-th>  شخص</b-th>
                      <b-th>  تلفن</b-th>
                      <b-th>موبایل</b-th>
                      <b-th>ایمیل</b-th>
                      <b-th>
                        <small>سمت/یادداشت</small>
                      </b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody @click="$router.push({ path:'/contact/profile/'+issue.contact.id, params: {id:issue.contact.id}})" style="cursor: pointer">
                    <b-tr>
                      <b-td>
                        <b v-if="issue.contact.last_name"> {{issue.contact.first_name }} {{issue.contact.last_name }}</b>
                      </b-td>
                      <b-th>
                        <b v-if="issue.contact.tell"> {{issue.contact.tell}}</b>
                      </b-th>
                      <b-td>
                        <b v-if="issue.contact.mobile"> {{issue.contact.mobile}}</b>
                      </b-td>
                      <b-td>
                        <b v-if="issue.contact.email"> {{issue.contact.email}}</b>
                      </b-td>
                      <b-td>
<!--                        <small v-if="sub_contact.note"> {{sub_contact.note }}</small>-->
                      </b-td>
                    </b-tr>
                  </b-tbody>

                  <b-tbody v-if="issue.contact.sub_contacts" v-for="(sub_contact , sub_contactKey) in issue.contact.sub_contacts" :key="sub_contactKey"
                           @click="$router.push({ path:'/contact/profile/'+issue.contact.id, params: {id:issue.contact.id}})" style="cursor: pointer">
                    <b-tr>
                      <b-td>
                        <span v-if="sub_contact.last_name"> {{sub_contact.first_name }} {{sub_contact.last_name }}</span>
                      </b-td>
                      <b-th>
                        <span v-if="sub_contact.tell"> {{sub_contact.tell}}</span>
                      </b-th>
                      <b-td>
                        <span v-if="sub_contact.mobile"> {{sub_contact.mobile}}</span>
                      </b-td>
                      <b-td>
                        <span v-if="sub_contact.email"> {{sub_contact.email}}</span>
                      </b-td>
                      <b-td>
                        <small v-if="sub_contact.other_info"> {{sub_contact.other_info }}</small>
                      </b-td>
                    </b-tr>
                  </b-tbody>



                </b-table-simple>

              </div>
            </div>

            <div v-if="issue.order" class="card m-3 p-3">

              <router-link v-if="issue.order_id && issue.order_id != 'null' && issue.order" :to="{path: '/order/payment/'+issue.order_id, params: {id: issue.order_id}}"
                           class="btn btn-sm btn-pill btn-info mb-3"> فاکتور:  {{issue.order.id}}
              </router-link>
              <order-invoice v-if="issue.order" :order="issue.order" :edit="false"></order-invoice>

            </div>

              <div>
                  <hr  v-if="issueMoreDetailShow">
                  <b-row  class="mb-2" >


                        <b-col  md="4" class="text-right">

                         <span title="نمایش issue های بیشتر" @click="getSubIssues()" class="mx-1" style="cursor: pointer;color: #9e9e9e;font-size: 22px" >
                                                          <i class="fas fa-archive"></i>
                          </span>

                          <span  v-if="issueMoreDetailShow" title="یادداشت ها/ نظرات" v-on:click="showIssueComments(issue.id)" class="mx-2" style="cursor: pointer;color: #9e9e9e;font-size: 22px">
                                                          <i class="fas fa-comments text-gray mx-10"></i>
                           </span>


                            <span title="افزودن Sub-Issue" @click="$bvModal.show('modal-issue'+issue.id)" class="mx-1" style="cursor: pointer;color: #9e9e9e;font-size: 22px">
                                                          <i class="fas fa-plus text-gray mx-10"></i>
                           </span>
<!--                            <CButton-->
<!--                                    @click="$bvModal.show('modal-issue'+issue.id)"-->
<!--                                    color="secondary"-->
<!--                                    class="btn-sm text-left"-->
<!--                                    size="sm"-->
<!--                            >-->
<!--                                افزودن Sub-Issue-->
<!--                            </CButton>-->
                      </b-col>


                      <b-col v-b-tooltip.hover :title="'زمان شروع:'+issue.start_date"   v-if="issueMoreDetailShow" md="4"  class="text-left">
                          <small> مدت تخمینی (ساعت): </small>
                          <b>{{issue.estimated_time}}</b>
                      </b-col>
                      <b-col v-b-tooltip.hover :title="'جهت انجام:'+issue.due_date"   v-if="issueMoreDetailShow" md="4"  class="text-left">
                          <small>درصد پیشرفت: </small>
                          <b>{{issue.progress_input}}</b>
                      </b-col>



                  </b-row>



                  <b-modal style="border: 2px solid yellowgreen!important;"
                           :id="'modal-issue'+issue.id"
                           color="warning"
                           size="xl"
                           :title="issue.title"
                  >






                      <b-col v-if="2==3"  md="12" class=" pt-2" :style="{borderTop: headerStyles(issue)}" style="background-color: #fff">

                          <div style="height: 35px">
                              <div>
                                  <!--                                                  <div class="user-image" v-if="issue.public_user.public_profile">-->
                                  <!--                                                      <img v-if="issue.public_user.public_profile.image"-->
                                  <!--                                                           :src="'/'+issue.public_user.public_profile.image" style="height: 30px" :alt="issue.public_user.name+' '+issue.public_user.family" class="">&ensp;-->
                                  <!--                                                  </div>-->
                                  <router-link :to="{path : 'profile/'+issue.public_user.id }" >
                                            <span class="float-right">
                                                <span>
                                                  {{issue.public_user.name}}
                                                </span>
                                                &ensp;<i v-if="2==3" class="fas fa-check-circle text-color-blue"></i>
                                            </span>
                                  </router-link>

                                  <small class="text-color-blue text-left " style="float: left">

                                      <span v-if="issue.type_object" v-b-tooltip.hover :title="issueTypeText(issue)" v-text="issue.type_object.title" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}"></span>




                                      {{issue.created_at| moment("dddd, jD jMMMM  jYYYY") }} <i class="far fa-clock"></i>
                                  </small>
                              </div>
                          </div>

                          <div>

                              <div>


                                  <b-badge v-if="issue.priority == 3"  pill class="text-left p-1 mr-2" style="background-color: #212121;border: 1px solid #880e4f;float: left">اولویت زیاد</b-badge>
                                  <b-badge v-else-if="issue.priority == 2"   pill class="text-left p-1 mr-2" style="background-color: #757575;float: left">اولویت متوسط</b-badge>
                                  <b-badge v-else-if="issue.priority == 1"  pill  class="text-left p-1 mr-2" style="background-color: #9e9e9e;float: left">اولویت کم</b-badge>





                                  <b-badge  v-if="issue.board" pill variant="info" class="text-left p-1" style="float: left"
                                            :style="{backgroundColor: boardColor(issue.board.id)}">
                                      {{issue.board.title}}
                                  </b-badge>

                                  <!--                                                  <small  v-if="issue.public_user.public_profile" class="float-right text-color-gray"> {{issue.public_user.public_profile.education}}-->
                                  <!--                                                  </small>-->
                                  <span class="text-color-gray">


                                                                                  <!--                                                <i class="fas fa-heart"></i>&ensp;{{issue.like}}&ensp;&ensp;-->
                                      <!--                                                <i class="fas fa-comments text-gray"></i>&ensp;{{issue.comments.length}}-->
                                            </span>
                              </div>

                          </div>


                          <h4  class="mt-0 pt-0 " v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h4>
                          <!--                                        <pre style="font-family:IRANSans , sans-serif !important " v-html="issue.intro"></pre>-->
                          <p v-if="issue.description && issue.description != '-'"  v-html="issue.description.replace(/(?:\r\n|\r|\n)/g, '<br>')" style="overflow: hidden; direction: rtl!important;text-align: right!important;"></p>
                          <small v-if="issue.text && issue.text != 'null' && issue.text != '0'" v-on:click="showIssueText(issue.text, issueIndex)" style="color: darkgrey;cursor: pointer">نمایش ادامه...</small>


                          <p v-if="issueMoreDetailShow && issue.tags">
                              <b-badge class="m-1"  v-for="(tag, tagIndex) in issue.tags" :key="'tag-'+tagIndex" variant="primary">{{tag.title}}</b-badge>
                          </p>


                          <div>
                              <b-row class="mb-2">
                                  <b-col  md="6" class="text-right">


                                      <!--                                                      <span v-on:click="likeIssue(issue)" >-->
                                      <!--&lt;!&ndash;                                                          <i :id="'like-fas-'+issue.id"  v-if="issue.user_like.length" class="fas fa-heart mx-10 "></i>&ndash;&gt;-->
                                      <!--                                                          <i :id="'like-far-'+issue.id"  class="far fa-heart mx-10"></i>-->
                                      <!--                                                      </span>-->

                                      <span v-on:click="issue.comment = !issue.comment" >
                                                          <i class="fas fa-comments text-gray mx-10"></i>

                                                      </span>
                                      <!--                                                <i class="fas fa-user-plus mx-10"></i>-->
                                  </b-col>
                                  <b-col md="6"  class="text-left">





                                      <nav class="nav justify-content-end">
                                          <!--                                                    <a class="position-absolute" href="#" style="left: 20px;"><img-->
                                          <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                          <!--                                                    <a class="position-absolute" href="#" style="left: 40px;"><img-->
                                          <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                          <!--                                                    <a class="position-absolute" href="#" style="left: 60px;"><img-->
                                          <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->

                                      </nav>

                                  </b-col>
                              </b-row>






                            <div  v-if="issueMoreDetailShow" :id="'issue-item-main-'+issue.id" style="display: none">
                              <div>
                                <b-row  class="text-right  py-1 mx-1 my-1" style="border: 1px solid #eee;border-radius: 4px">


                                  <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                    <div>
                                      <!--                                      <b-textarea-->
                                      <!--                                              :id="'newComment-'+issue.id"   class=""-->
                                      <!--                                              placeholder="نظر/یادداشت خود را وارد کنند…" rows="1"-->
                                      <!--                                              :rules="rules"-->
                                      <!--                                      ></b-textarea>-->
                                      <!--                                      <b-button @click="sendComment(issue.id)" variant="success btn-sm px-1 mt-1"-->
                                      <!--                                      >ثبت نظر/یادداشت</b-button>-->

                                      <CTextarea
                                          :id="'newComment-'+issue.id"   class=""
                                          placeholder="نظر/یادداشت خود را وارد کنند…" rows="1"
                                          :rules="rules"
                                      >
                                        <!--                                      <template #prepend>-->
                                        <!--                                        <CButton color="primary"><i class="fas fa-user"></i></CButton>-->
                                        <!--                                      </template>-->
                                        <template #append>
                                          <CButton @click="sendComment(issue.id)" color="dark" size="sm">
                                            <i class="fas fa-comment"></i>
                                          </CButton>
                                        </template>
                                      </CTextarea>


                                    </div>

                                  </b-col>


                                </b-row>


                              </div>




                            </div>


                            <div v-if="issue.attaches" >
                              <hr>
                            </div>


                            <div v-if="issue.attaches" class="text-right">

                              <b-carousel id="carouselAttachesM"  ref="carouselAttachesM" class="h-100 mb-1" :interval="80000"
                                          no-wrap indicators  background="#eeeeee"
                                          style="text-shadow: 1px 1px 2px #333;">

                                <b-carousel-slide v-for="(issueFile, fileIndex) in issue.attaches" :key="fileIndex"
                                >
                                  <template v-slot:img>
                                    <div v-if="issueFile.type == 'image'" class="text-center " style="max-height: 500px;overflow: hidden">
                                      <!--                                              <img :title="issueFile.note"-->
                                      <!--                                                   :src="'/'+issueFile.file" :alt="issue.title" class="w-100">-->

                                      <inner-image-zoom :title="issueFile.note"  :alt="issue.title" :src="'/'+issueFile.file" :zoomSrc="'/'+issueFile.file" class="w-100" style="width: 100%"/>

                                    </div>


                                    <audio  v-if="issueFile.type == 'voice'" :src="'/'+issueFile.file"
                                            controls class="w-100 my-4">
                                    </audio>

                                    <video  v-if="issueFile.type == 'video'" class="w-100" controls>
                                      <source :src="'/'+issueFile.file" type="video/mp4">
                                      <source :src="'/'+issueFile.file" type="video/ogg">
                                      Your browser does not support HTML5 video.
                                    </video>

                                    <div  v-if="issueFile.type == 'file'" class="text-center my-5">
                                      <a target="_blank" class="btn btn-info btn-sm " v-if="issueFile.type == 'file'" :href="'/'+issueFile.file" >
                                        دانلود پیوست
                                      </a>
                                    </div>


                                  </template>
                                </b-carousel-slide>

                              </b-carousel>


                              <span v-if="issue.attaches" class="mb-3">
                                 <small v-if="issue.attaches.length >1" @click="prev()"> پیوست قبلی</small>
                                  <small v-if="issue.attaches.length >1" @click="next()"  style="float: left" > پیوست بعدی</small>
                              </span>

                            </div>



                            <div class="mb-3">
                              <div v-for="(comment, commentIndex) in issue.comments" :key="commentIndex"
                              >
                                <b-row  :id="`popover-1-${comment.id}`" class="text-right  py-1 mx-1 my-1" style="background-color: #eee;border-radius: 4px" >

                                  <b-col md="3" class="ml-0 pl-0 py-0  my-0"  >
                                    <router-link :to="{path : 'profile/'+comment.public_user.id }"  class="user-image ml-0 pl-0" :title="comment.public_user.name">
                                      <img v-if="comment.public_user.image"
                                           :src="'/'+comment.public_user.image" style="height: 30px" :alt="comment.public_user.name" class="">
                                      <img v-else
                                           :src="'/icon/user-avatar.png'" style="height: 30px"  class="">
                                      <small>&ensp;{{comment.public_user.name}}&ensp;</small>
                                    </router-link>
                                  </b-col>
                                  <b-col md="9" class="mr-0 py-0  pt-1 pb-0 my-0">
                                    <small  class="mr-0 pr-0 ">
                                      {{comment.comment}}

                                    </small>
                                  </b-col>
                                </b-row>


                                <b-popover
                                    :target="`popover-1-${comment.id}`"
                                    placement="top"
                                    triggers="hover focus"
                                    :content="`Placement ${comment.id}`"

                                >
                                  <!--                                                    <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                  <b-btn v-on:click="showReplyForm(issue.id, comment.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                </b-popover>


                                <b-row :id="'reply-form-'+issue.id+'-'+comment.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                  <b-col md="12" class="mr-0 py-0  pt-1 mb-1 ">
                                    <div>
                                      <b-textarea :id="'reply-'+issue.id+'-'+comment.id"
                                                  class=""
                                                  placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                  :rules="rules"
                                      ></b-textarea>
                                      <b-button @click="sendReply(issue.id, comment.id)" variant="success btn-sm px-1 mt-0"
                                      >ثبت پاسخ</b-button>
                                      <b-btn class="btn-sm" @click="hideForm(issue.id, comment.id)"><i class="fas fa-minus-square"></i></b-btn>

                                    </div>
                                  </b-col>
                                </b-row>




                                <div v-for="(reply, replyIndex) in comment.answers" :key="replyIndex"
                                >
                                  <b-row  :id="`popover-1-${reply.id}`" class="text-right  py-1 mx-1 my-1 mr-5" style="border:1px solid #eee;border-radius: 4px" >

                                    <b-col md="3" class="ml-0 pl-0 py-0  my-0"  >
                                      <router-link :to="{path : 'profile/'+reply.public_user.id }"  class="user-image ml-0 pl-0" :title="reply.public_user.name">
                                        <img v-if="reply.public_user.image"
                                             :src="'/'+reply.public_user.image" style="height: 30px" :alt="reply.public_user.name" class="">
                                        <img v-else
                                             :src="'/icon/user-avatar.png'" style="height: 30px"  class="">
                                        <small>&ensp;{{reply.public_user.name}}&ensp;</small>
                                      </router-link>
                                    </b-col>
                                    <b-col md="9" class="mr-0 py-0  pt-1 pb-0 my-0">
                                      <small  class="mr-0 pr-0 ">
                                        {{reply.comment}}

                                      </small>
                                    </b-col>
                                  </b-row>


                                  <b-popover
                                      :target="`popover-1-${reply.id}`"
                                      placement="top"
                                      triggers="hover focus"
                                      :content="`Placement ${reply.id}`"

                                  >
                                    <!--                                                        <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                    <b-btn v-on:click="showReplyForm(issue.id, reply.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                  </b-popover>


                                  <b-row :id="'reply-form-'+issue.id+'-'+reply.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                    <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                      <div>
                                        <b-textarea :id="'reply-'+issue.id+'-'+reply.id"
                                                    class=""
                                                    placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                    :rules="rules"
                                        ></b-textarea>
                                        <b-button @click="sendReplyOfReply(issue.id, comment.id,reply.id)" variant="success btn-sm px-1 mt-0"
                                        >ثبت پاسخ</b-button>
                                        <b-btn class="btn-sm" @click="hideForm(issue.id, reply.id)"><i class="fas fa-minus-square"></i></b-btn>

                                      </div>
                                    </b-col>
                                  </b-row>

                                </div>









                              </div>
                              <small style="cursor: pointer" @click="getMoreComments(issue.id)">یادداشت های بیشتر</small>

                            </div>



                          </div>
                      </b-col>




                      <b-card style="background-color: #eee">
                          <addIssue  :parent_id="issue.id"
                                     :reply_id="addIssue.reply_id"
                                     :sprint_id="issue.sprint_id"
                                     :board_id="issue.board_id"
                                     :process_id="issue.process_id"
                                     :step_id="issue.step_id"
                                     :type="6"
                                     :contact_id="issue.contact_id"
                                     :project_id="issue.project_id"
                                     :section_id="addIssue.section_id">
                          </addIssue>
                      </b-card>





                      <b-row v-for="(issue, issueIndex) in issue.issues" :key="issueIndex" class="my-1  mr-5"
                             style="border: 2px solid #e2e2e2; border-radius: 5px;box-shadow: 0 0 4px rgba(0,0,0,0.3)">

                          <subIssueItemShow  :issue="issue"  :issueMoreDetailShow="issueMoreDetailShow">
                          </subIssueItemShow>

                      </b-row>





                  </b-modal>







                  <nav class="nav justify-content-end">
                      <!--                                                    <a class="position-absolute" href="#" style="left: 20px;"><img-->
                      <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                      <!--                                                    <a class="position-absolute" href="#" style="left: 40px;"><img-->
                      <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                      <!--                                                    <a class="position-absolute" href="#" style="left: 60px;"><img-->
                      <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->

                  </nav>

                <div  v-if="issueMoreDetailShow" :id="'issue-item-main-'+issue.id" style="display: none">
                  <div>
                    <b-row  class="text-right  py-1 mx-1 my-1" style="border: 1px solid #eee;border-radius: 4px">


                      <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                        <div>
                          <!--                                      <b-textarea-->
                          <!--                                              :id="'newComment-'+issue.id"   class=""-->
                          <!--                                              placeholder="نظر/یادداشت خود را وارد کنند…" rows="1"-->
                          <!--                                              :rules="rules"-->
                          <!--                                      ></b-textarea>-->
                          <!--                                      <b-button @click="sendComment(issue.id)" variant="success btn-sm px-1 mt-1"-->
                          <!--                                      >ثبت نظر/یادداشت</b-button>-->

                          <CTextarea
                              :id="'newComment-'+issue.id"   class=""
                              placeholder="نظر/یادداشت خود را وارد کنند…" rows="1"
                              :rules="rules"
                          >
                            <!--                                      <template #prepend>-->
                            <!--                                        <CButton color="primary"><i class="fas fa-user"></i></CButton>-->
                            <!--                                      </template>-->
                            <template #append>
                              <CButton @click="sendComment(issue.id)" color="dark" size="sm">
                                <i class="fas fa-comment"></i>
                              </CButton>
                            </template>
                          </CTextarea>


                        </div>

                      </b-col>


                    </b-row>


                  </div>




                </div>


                <div v-if="issue.attaches" >
                  <hr>
                </div>


                <div v-if="issue.attaches" class="text-right">

                  <b-carousel id="carouselAttachesM"  ref="carouselAttachesM" class="h-100 mb-1" :interval="80000"
                              no-wrap indicators  background="#eeeeee"
                              style="text-shadow: 1px 1px 2px #333;">

                    <b-carousel-slide v-for="(issueFile, fileIndex) in issue.attaches" :key="fileIndex"
                    >
                      <template v-slot:img>
                        <div v-if="issueFile.type == 'image'" class="text-center " style="max-height: 500px;overflow: hidden">
                          <!--                                              <img :title="issueFile.note"-->
                          <!--                                                   :src="'/'+issueFile.file" :alt="issue.title" class="w-100">-->

                          <inner-image-zoom :title="issueFile.note"  :alt="issue.title" :src="'/'+issueFile.file" :zoomSrc="'/'+issueFile.file" class="w-100" style="width: 100%"/>

                        </div>


                        <audio  v-if="issueFile.type == 'voice'" :src="'/'+issueFile.file"
                                controls class="w-100 my-4">
                        </audio>

                        <video  v-if="issueFile.type == 'video'" class="w-100" controls>
                          <source :src="'/'+issueFile.file" type="video/mp4">
                          <source :src="'/'+issueFile.file" type="video/ogg">
                          Your browser does not support HTML5 video.
                        </video>

                        <div  v-if="issueFile.type == 'file'" class="text-center my-5">
                          <a target="_blank" class="btn btn-info btn-sm " v-if="issueFile.type == 'file'" :href="'/'+issueFile.file" >
                            دانلود پیوست
                          </a>
                        </div>


                      </template>
                    </b-carousel-slide>

                  </b-carousel>


                  <span v-if="issue.attaches" class="mb-3">
                                 <small v-if="issue.attaches.length >1" @click="prev()"> پیوست قبلی</small>
                                  <small v-if="issue.attaches.length >1" @click="next()"  style="float: left" > پیوست بعدی</small>
                              </span>

                </div>





                <!-- comments -->
                <div class="mb-3">
                    <div v-for="(comment, commentIndex) in issue.comments" :key="commentIndex"
                    >
                      <b-row  :id="`popover-1-${comment.id}`" class="text-right  py-1 mx-1 my-1" style="background-color: #eee;border-radius: 4px" >

                        <b-col md="3" class="ml-0 pl-0 py-0  my-0"  >
                          <router-link :to="{path : 'profile/'+comment.public_user.id }"  class="user-image ml-0 pl-0" :title="comment.public_user.name">
                            <img v-if="comment.public_user.image"
                                 :src="'/'+comment.public_user.image" style="height: 30px" :alt="comment.public_user.name" class="">
                            <img v-else
                                 :src="'/icon/user-avatar.png'" style="height: 30px"  class="">
                            <small>&ensp;{{comment.public_user.name}}&ensp;</small>
                          </router-link>
                        </b-col>
                        <b-col md="9" class="mr-0 py-0  pt-1 pb-0 my-0">
                          <small  class="mr-0 pr-0 ">
                            {{comment.comment}}

                          </small>
                        </b-col>
                      </b-row>


                      <b-popover
                          :target="`popover-1-${comment.id}`"
                          placement="top"
                          triggers="hover focus"
                          :content="`Placement ${comment.id}`"

                      >
                        <!--                                                    <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                        <b-btn v-on:click="showReplyForm(issue.id, comment.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                      </b-popover>


                      <b-row :id="'reply-form-'+issue.id+'-'+comment.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                        <b-col md="12" class="mr-0 py-0  pt-1 mb-1 ">
                          <div>
                            <b-textarea :id="'reply-'+issue.id+'-'+comment.id"
                                        class=""
                                        placeholder="پاسخ خود را وارد کنند…" rows="1"
                                        :rules="rules"
                            ></b-textarea>
                            <b-button @click="sendReply(issue.id, comment.id)" variant="success btn-sm px-1 mt-0"
                            >ثبت پاسخ</b-button>
                            <b-btn class="btn-sm" @click="hideForm(issue.id, comment.id)"><i class="fas fa-minus-square"></i></b-btn>

                          </div>
                        </b-col>
                      </b-row>




                      <div v-for="(reply, replyIndex) in comment.answers" :key="replyIndex"
                      >
                        <b-row  :id="`popover-1-${reply.id}`" class="text-right  py-1 mx-1 my-1 mr-5" style="border:1px solid #eee;border-radius: 4px" >

                          <b-col md="3" class="ml-0 pl-0 py-0  my-0"  >
                            <router-link :to="{path : 'profile/'+reply.public_user.id }"  class="user-image ml-0 pl-0" :title="reply.public_user.name">
                              <img v-if="reply.public_user.image"
                                   :src="'/'+reply.public_user.image" style="height: 30px" :alt="reply.public_user.name" class="">
                              <img v-else
                                   :src="'/icon/user-avatar.png'" style="height: 30px"  class="">
                              <small>&ensp;{{reply.public_user.name}}&ensp;</small>
                            </router-link>
                          </b-col>
                          <b-col md="9" class="mr-0 py-0  pt-1 pb-0 my-0">
                            <small  class="mr-0 pr-0 ">
                              {{reply.comment}}

                            </small>
                          </b-col>
                        </b-row>


                        <b-popover
                            :target="`popover-1-${reply.id}`"
                            placement="top"
                            triggers="hover focus"
                            :content="`Placement ${reply.id}`"

                        >
                          <!--                                                        <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                          <b-btn v-on:click="showReplyForm(issue.id, reply.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                        </b-popover>


                        <b-row :id="'reply-form-'+issue.id+'-'+reply.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                          <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                            <div>
                              <b-textarea :id="'reply-'+issue.id+'-'+reply.id"
                                          class=""
                                          placeholder="پاسخ خود را وارد کنند…" rows="1"
                                          :rules="rules"
                              ></b-textarea>
                              <b-button @click="sendReplyOfReply(issue.id, comment.id,reply.id)" variant="success btn-sm px-1 mt-0"
                              >ثبت پاسخ</b-button>
                              <b-btn class="btn-sm" @click="hideForm(issue.id, reply.id)"><i class="fas fa-minus-square"></i></b-btn>

                            </div>
                          </b-col>
                        </b-row>

                      </div>









                    </div>
                    <small style="cursor: pointer" @click="getMoreComments(issue.id)">یادداشت های بیشتر</small>

                </div>





                  <div>
                      <b-row v-for="(issue, issueIndex) in issue.issues" :key="issueIndex" class="my-1  mr-5"
                             style="border: 0px solid #e2e2e2; border-radius: 5px;box-shadow: 0 0 4px rgba(0,0,0,0.3);
                                        color: #444!important;"
                      >

                          <subIssueItemShow  :issue="issue"  :issueMoreDetailShow="issueMoreDetailShow">
                          </subIssueItemShow>

                      </b-row>



<!--                      <b-btn @click="getSubIssues()" variant="info"> More Issues</b-btn>-->






                  </div>

              </div>
          </b-col>
      </div>










      <div :id="'add-attachment-main-'+issue.id" class="modal fade" role="dialog">
          <div class="modal-dialog">

              <!-- Modal content-->
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close"
                              data-dismiss="modal">&times;</button>


                      <div class="modal-title">
                           افزودن پیوست
                      </div>
                  </div>
                  <div class="modal-body">


                      <div class="row text-right">

                          <b-row class="ul-upload mt-1 mb-0 col-12  text-left" style="color: #666">
                              <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVoiceRecorder = !showVoiceRecorder"><i class="fas fa-microphone"></i></b-col>
                              <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showImageUploader = !showImageUploader"><i class="fas fa-image"></i></b-col>
                              <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVideoUploader = !showVideoUploader"><i class="fas fa-film"></i></b-col>
                              <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showFileUploader = !showFileUploader"><i class="fas fa-paperclip"></i></b-col>

                          </b-row>

                          <b-row>
                              <div class="col-12">





                                  <div v-if="showVoiceRecorder" class="d-flex justify-content-center w-100 px-2 my-1">
                                      <!--                                                <audio-recorder-->
                                      <!--                                                        v-model="newIssue.voice"-->
                                      <!--                                                        :attempts="1"-->
                                      <!--                                                        :time="2"-->
                                      <!--                                                        :show-upload-button="false"-->
                                      <!--                                                        :before-recording="callback"-->
                                      <!--                                                        :pause-recording="callback"-->
                                      <!--                                                        :after-recording="callback"-->
                                      <!--                                                        :select-record="callback"-->
                                      <!--                                                        :before-upload="callback"-->
                                      <!--                                                        :successful-upload="callback"-->
                                      <!--                                                        :failed-upload="callback"/>-->

                                      <vue-record-audio   v-model="newIssue.voice" @result="onResult"  />

                                      <audio  :src="srcPlay"  controls class="w-100 mr-2 mt-1" style="min-width: 190px">
                                      </audio>

                                  </div>

                                  <div v-if="showFileUploader" class="d-flex justify-content-center w-100 px-5 my-1" >

                                      <div class="ar">
                                          <label>فایل را انتخاب کنید</label>

                                          <b-form-file v-model="newIssue.file" placeholder="فایل را انتخاب کنید" drop-placeholder="Drop file here..."
                                                       plain>
                                          </b-form-file>
                                          <!--                                                          <div class="text-center my-2" v-if="newIssue.file">-->
                                          <!--                                                              <b-form-checkbox v-model="newIssue.fileLib"  :disabled="IssueAsForum" name="check-button" switch class="d-inline" ></b-form-checkbox>-->
                                          <!--                                                              <span  class="mr-1"  style="color: #e65100">انتشار فایل در کتابخانه</span>-->
                                          <!--                                                          </div>-->
                                      </div>

                                  </div>

                                  <div v-if="showImageUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                      <div class="ar " >
                                          <label>تصویر را انتخاب کنید</label>
                                          <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                          <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                          <b-form-file v-model="newIssue.image" placeholder="تصویر را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                          </b-form-file>

                                          <!--                                                    <input type="file" class="" ref="file" @change="onFileChangeImage($event)"-->
                                          <!--                                                           placeholder="تصویر را انتخاب کنید"/>-->


                                      </div>

                                  </div>

                                  <div v-if="showVideoUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                      <div class="ar" >
                                          <label>ویدئو را انتخاب کنید</label>
                                          <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                          <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                          <b-form-file  v-model="newIssue.video" placeholder="ویدئو را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                          </b-form-file>
                                      </div>

                                  </div>



                              </div>
                          </b-row>



                      </div>

                  </div>
                  <div class="modal-footer">


                      <button @click="addIssueAttach(issue.id)" type="button" class="btn btn-success"
                              data-dismiss="modal" >ثبت</button>

                      <button type="button" class="btn btn-default"
                              data-dismiss="modal" >بستن</button>

                  </div>
              </div>

          </div>
      </div>














  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>

import Multiselect from 'vue-multiselect'

import InnerImageZoom from 'vue-inner-image-zoom';



import addIssue from './add'
import subIssueItemShow from './subItem'
import lodash from 'lodash'
import editIssue from "./edit";
import OrderInvoice from "./../order/invoice";




export default {
  name: 'item',
  components: {
    OrderInvoice,


      Multiselect,
      addIssue,
      subIssueItemShow,
      editIssue,


      'inner-image-zoom': InnerImageZoom








  },



    props: {
        issue: null,
        issueMoreDetailShow: true,
        // processes: [],
        // steps: [],
        // orders: [],
        // contacts: [],
        // projects: [],
    },


    data () {
        return {

            auth: {
                headers: {
                    Authorization: 'bearer ' + localStorage.getItem('token')
                }
            },


            role: localStorage.getItem('role'),
            authUser:
                {
                    id:localStorage.getItem('id'),
                },



            loadMore: true,
            page: 1,
            pageSize: 10,
            voice: '',

            courseCategories:[],
            fileCategories:[],
            forumCategories:[],
            forums:[],


            issues:[],
            issueText: 0,


            rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

            showVoiceRecorder: false,
            showFileUploader: false,
            showImageUploader: false,
            showVideoUploader: false,

            src: null,
            srcPlay: null,

            issueAsCourse: false,
            issueAsForum: false,

            courseDisabled: false,
            forumDisabled: false,

            newComment:'',
            newReply:'',

            options:[],
            assignOptions:[],

            selectedTags: [],
            tags: [],
            isLoading: false,




            typeOptions: [
                { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
                { value: 'bug', text: 'ایراد (Bug)' },
                { value: 'task', text: 'فعالیت (Task)' },
                { value: 'story', text: 'لیست (Story)' },
                { value: 'epic', text: 'نسخه/فیچر (Epic)' },
                { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
                { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

            ],



            warningModal: false,


            search: {

                title: '',
                description: '',
                type: '',
                project_id: '',
                section_id: '',
                process_id: '',
                step_id: '',
                board_id: '',

                created_at_from: '',
                created_at_to: '',
                done_date: '',
                start_date: '',
                done_date_from: '',
                done_date_to: '',
                close_date: '',

                priority: '',
                contact_id: '',
                order_id: '',
                person_id: '',
                created_by: '',
                updated_by: '',
            },


            contact_id: '',





            addIssue: {
                parent_id: null,
                reply_id: null,
                sprint_id: null,
                board_id: null,
                process_id: null,
                section_id: null,
                step_id: null
            },





            newIssue: {
                intro:'',
                description:'',
                state:'0',
                title:'',
                text:'0',

                progress_input:'',

                voice:'',
                file:'',
                image:'',
                video:'',

                news:0,
                course_id:null,
                course_category_id:null,
                forum_id:null,
                forum_category_id:null,
                fileLib_tags:null,
                // issue_likes:null,
                // userLike:null,
                type:'ticket',
                project_id:null,
                board_id:2,
                users:[],

                priority:2,
                start_date:null,
                done_date:null,
                tags:[],
                // parent_id:null
            },

            users:[],

            steps: [],
            orders: [],
            processes: [],
            contacts: [],
            projects: [],


            editIssueState: false

        }
    },



    watch: {

        },



    mounted() {



        // this.getSteps()



        //  move to edit
        // this.getProcesses()
        // this.getProjects()
        // this.getOrders()
        // this.getContacts()
        // this.getUsers()
    },



    methods: {


        getIssues(){

            console.log('this.$parent.getIssues()')
            this.$parent.getIssues()
        },


        color (value) {
            let $color
            if (value <= 25) {
                $color = 'info'
            } else if (value > 25 && value <= 50) {
                $color = 'success'
            } else if (value > 50 && value <= 75) {
                $color = 'warning'
            } else if (value > 75 && value <= 100) {
                $color = 'danger'
            }
            return $color
        },

        bottomVisible() {
            const scrollY = window.scrollY
            const visible = document.documentElement.clientHeight
            const pageHeight = document.documentElement.scrollHeight
            const bottomOfPage = visible + scrollY >= pageHeight
            return bottomOfPage || pageHeight < visible
        },

        pluck(array, key) {
            return array.map(function (obj) {
                return obj[key];
            });
        },

        showIssueText(text, index ){

            this.issues[index].intro = text

        },

        onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
            this.srcPlay =  window.URL.createObjectURL(data)
            this.src =  data

        },

        headerStyles(issueType){
            if (issueType.type == 1)
                return '2px solid #880e4e'
            else if (issueType.type == 2)
                return '2px solid #f50057'
            else if (issueType.type == 3)
                return '2px solid #8e24aa'
            else if (issueType.type == 4)
                return '2px solid #263238'
            else if (issueType.type == 5)
                return '2px solid #dd2c00'
            else if (issueType.type == 6)
                return '2px solid #00c853'
            else if (issueType.type == 7)
                return '2px solid #0097a7'
            else if (issueType.type == 8)
                return '2px solid #0288d1'
            else if (issueType.type == 9)
                return '2px solid #0208ff'
            else if (issueType.type == 10)
                return '2px solid #eeb600'
            else if (issueType.type == 10)
                return '2px solid #0e8e2e'
            else if (issueType.type == 11)
                return '2px solid #888'
            else
                return '2px solid #888888'
        },

        boardColor(boardID){
            if (boardID == 1)
                return '#ee6600'
            else if (boardID == 2)
                return '#ffd600'
            else if (boardID == 3)
                return '#aeb130'
            else if (boardID == 4)
                return '#64dd17'
            else if (boardID == 5)
                return '#0097a7'
            else if (boardID == 6)
                return '#00bfa5'
            else
                return ''
        },

        typeBadgeStyles(issueType){
            if (issueType.type == 1)
                return '#880e4e'
            else if (issueType.type == 2)
                return '#f50057'
            else if (issueType.type == 3)
                return '#8e24aa'
            else if (issueType.type == 4)
                return '#263238'
            else if (issueType.type == 5)
                return '#dd2c00'
            else if (issueType.type == 6)
                return '#00c853'
            else if (issueType.type == 7)
                return '#0097a7'
            else if (issueType.type == 8)
                return '#0288d1'
            else if (issueType.type == 9)
                return '#0208ff'
            else if (issueType.type == 10)
                return '#eeb600'
            else if (issueType.type == 10)
                return '#0e8e2e'
            else if (issueType.type == 11)
                return '#888'
            else
                return '#888888'
        },

        getCourseCategories(){
            var app = this;
            axios.get('/api/admin/list/5', app.auth)
                .then(function (response) {
                    app.courseCategories = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getFileCategories(){
            var app = this;
            axios.get('/api/file/tagSearch/', app.auth)
                .then(function (response) {
                    app.fileCategories = response.data.data.tags.data

                    // console.log(response.data.data.tags.data)


                    for (const key in app.fileCategories) {
                        if (app.fileCategories.hasOwnProperty(key)) {
                            const element = app.fileCategories[key];

                            app.options.push({
                                title: '#'+element.title,
                                id: element.id
                            })
                            // this.details[0].
                        }
                    }
                    // console.log(app.options)


                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getForumCategories(){
            var app = this;
            axios.get('/api/admin/list/2', app.auth)
                .then(function (response) {
                    app.forumCategories = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getForums(){
            var app = this;
            axios.get('/api/forum/best', app.auth)
                .then(function (response) {
                    app.forums = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        updateForums(event){
            var categoryID = event;
            var app = this;
            axios.get('/api/forum/list?cat_id='+categoryID, app.auth)
                .then(function (response) {
                    app.forums = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        likeIssue(issue){
            var app = this;
            axios.get('/api/issue/like/'+issue.id, app.auth)
                .then(function (response) {

                    // console.log(app.issues.find(x => x.id == issue.id).user_like)

                    if (app.issues.find(x => x.id == issue.id).user_like.length == 0) {
                        app.$snotify.success('پسند شما برای این پست (Issue) ثبت شد');
                        $("#like-far-"+issue.id).attr("data-prefix","fas");
                        $("#like-fas-"+issue.id).attr("data-prefix","fas");
                        // $("#like-far-"+issue.id).removeClass("fas").addClass("far");
                        app.issues.find(x => x.id == issue.id).like ++
                        app.issues.find(x => x.id == issue.id).user_like.push({
                            types_id: 1,
                            users_id: 0,
                            targets_id: issue.id})
                    }
                    else{
                        app.$snotify.info('پسند شما برای این پست (Issue) لغو شد');
                        $("#like-fas-"+issue.id).attr("data-prefix","far");
                        $("#like-far-"+issue.id).attr("data-prefix","far");
                        // $("#like-fas-"+post.id).removeClass("far").addClass("fas");
                        app.issues.find(x => x.id == issue.id).like --
                        app.issues.find(x => x.id == issue.id).user_like = []
                    }


                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getUserLikes(issue){
            var app = this;
            axios.get('/api/intro/likes/'+issue.id, app.auth)
                .then(function (response) {
                    app.issues.find(x => x.id == issue.id).issue_likes = response.data

                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        showIssueComments(id){
            if (   $('#issue-item-main-'+id).css('display') == 'none')
                $('#issue-item-main-'+id).show();
            else
                $('#issue-item-main-'+id).hide();
        },

        sendComment(issueId){
            var app = this;
            var newItem = {
                parent_id: 0,
                issue_id: issueId,
                comment: document.getElementById('newComment-'+issueId).value,
            }

            axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                .then(function (resp) {
                    // console.log(resp,"IssueCreate")
                    app.newComment = ''
                    app.updateIssueComments(issueId)
                    app.$snotify.success('نظر/یادداشت با موفقیت ثبت شد');
                    document.getElementById('newComment-'+issueId).value = ''
                })
                .catch(
                    e => {
                        console.log(e.responsere);
                        app.$snotify.error('امکان ثبت نظر/یادداشت وجود ندارد');
                    }
                );

        },

        showReplyForm(issueId, commentID){
            $('#reply-form-'+issueId+'-'+commentID).show();
        },

        sendReply(issueId, commentID){
            var app = this;
            var newItem = {
                parent_id: commentID,
                issue_id: issueId,
                comment: document.getElementById('reply-'+issueId+'-'+commentID).value,
            }

            axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                .then(function (resp) {
                    // console.log(resp,"IssueCreate")
                    app.newComment = ''
                    app.updateIssueComments(issueId)
                    app.$snotify.success('پاسخ با موفقیت ثبت شد');
                    $('#reply-form-'+issueId+'-'+commentID).hide();
                    document.getElementById('reply-'+issueId+'-'+commentID).value = ''


                })
                .catch(
                    e => {
                        console.log(e.responsere);
                        app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                    }
                );

        },

        sendReplyOfReply(issueId, commentID, replyID){
            var app = this;
            var newItem = {
                parent_id: commentID,
                issue_id: issueId,
                comment: document.getElementById('reply-'+issueId+'-'+replyID).value,
            }

            axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                .then(function (resp) {
                    // console.log(resp,"IssueCreate")
                    app.newComment = ''
                    app.updateIssueComments(issueId)
                    app.$snotify.success('پاسخ با موفقیت ثبت شد');
                    $('#reply-form-'+issueId+'-'+replyID).hide();
                    document.getElementById('reply-'+issueId+'-'+replyID).value = ''


                })
                .catch(
                    e => {
                        console.log(e.responsere);
                        app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                    }
                );

        },

        hideForm(issueId, commentID){
            $('#reply-form-'+issueId+'-'+commentID).hide();
        },

        updateIssueComments(issueId){

            var app = this;
            axios.get('/api/intro/getComments/'+issueId+'/'+null, app.auth)
                // .then(function (response) {
                //     app.issues.find(x => x.id == issueId).comments = response.data.data.data
                //
                //     console.log(app.issues.find(x => x.id == issueId).comments)
                // })
                .then(res => {
                  app.issue.comments =[]
                  res.data.data.data.forEach(
                        (val)=>{app.issue.comments.push(val)});

                    if (res.data.data.data.length != 0)
                        app.issue.commentPage = res.data.data.current_page+1


                })
                .catch(function (e) {
                    console.log(e.response);
                });

        },

        getMoreComments(issueId){

            var app = this;
            // if (!app.issues.find(x => x.id == issueId).commentPage)
            //     app.issues.find(x => x.id == issueId).commentPage = 2

            if (!app.issue.commentPage)
                app.issue.commentPage = 2

            axios.get('/api/intro/getComments/'+issueId+'/'+null+'?page='+ app.issue.commentPage, app.auth)
                .then(res => {
                    res.data.data.data.forEach(
                        (val)=>{app.issue.comments.push(val)});

                    if (res.data.data.data.length != 0)
                        app.issue.commentPage = res.data.data.current_page+1


                })
                .catch(error => {
                    console.log(error);
                })



        },

        customLabel(option) {

            return `${option.title}`

        },

        addTag (newTag) {

            this.options.push({
                title: '@'+newTag,
                id: 0
            })
        },


        customLabelAssign(option) {

            return `${option.name}`

        },

        addAssign (newTag) {

            this.assignOptions.push({
                name: '@'+newTag,
                id: 0
            })
        },

        ajaxFindTag(query){

        },

        limitText (count) {
            return `and ${count} other tags`
        },

        asyncFind (query) {
            this.isLoading = true
            this.ajaxFindTag(query).then(response => {
                this.tags = response
                this.isLoading = false
            })
        },

        clearAll () {
            this.selectedTags = []
        },







        addOrder(issueId ,orderId){

            var app = this;

            var params= {
                order_id: orderId,
                // state: state,
            }

            axios.post(`/api/issue/addOrder/`+issueId,  params , app.auth)
                .then(function (resp) {
                    // console.log(resp,"")
                    // app.items.push(app.timing);
                    app.$snotify.success(' با موفقیت ثبت شد');

                    app.$parent.getIssues()
                })
                .catch(
                    e => {
                        console.log(e);
                        // app.$snotify.error('امکان ثبت وجود ندارد');
                    }
                );


        },

        changeContact(issueId ,contactId){

            var app = this;

            var params= {
                contact_id: contactId,
                // state: state,
            }

            axios.post(`/api/issue/changeContact/`+issueId,  params , app.auth)
                .then(function (resp) {
                    // console.log(resp,"")
                    // app.items.push(app.timing);
                    app.$snotify.success(' با موفقیت ثبت شد');

                    app.getStepsWithIssues()
                })
                .catch(
                    e => {
                        console.log(e);
                        app.$snotify.error('امکان ثبت وجود ندارد');
                    }
                );


        },

        setContactId(){

            // console.log(event)

            // this.newPost.contact_id = event.value
            this.newPost.contact_id = this.contact_id

            console.log(this.newPost.contact_id)
        },

        deleteIssue(id) {
            if (confirm("از حذف پست (issue) مطمئن هستید؟")) {
                var app = this;
                axios.get('/api/issue/delete/' + id, app.auth)
                    .then(function (resp) {
                        app.$snotify.success('حذف پست (issue) با موفقیت انجام شد');
                        app.$parent.getIssues()
                    })
                    .catch(function (resp) {
                        app.$snotify.danger("امکان حذف وجود ندارد");
                    });
            }
        },


      closeIssue(id) {
        if (confirm("از بستن (آرشیو کردن) issue مطمئن هستید؟")) {
          var app = this;
          axios.post('/api/issue/close/' + id, null, app.auth)
              .then(function (resp) {
                app.$snotify.success('بستن بستن (آرشیو کردن) issue  با موفقیت انجام شد');
                app.$parent.getIssues()
              })
              .catch(function (resp) {
                app.$snotify.danger("امکان بستن (آرشیو کردن) issue  وجود ندارد");
              });
        }
      },

        editIssue(issue) {
            var app = this;

            if (issue.title.length > 100 || issue.description.length > 300){
                app.$snotify.error('تعداد حروف بیشتر از  کاراکتر مجاز است! متن رو کوتاه تر نمایید. ');
            }else {

                issue.fieldWithVariable = JSON.stringify(app.returnIssueFields(issue.fields, issue.field_values, issue.type_object))

                if(issue.users){
                    if(issue.users.length !==0){
                        issue.users = app.pluck(issue.users,"id")
                    }
                }

                var newItem = issue;
                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                axios.post(`/api/intro/editIssue/`+issue.id,  formData , app.auth)
                    .then(function (resp) {
                        // console.log(resp,"editIssue")
                        // app.$parent.$parent.getIssues()
                        app.$snotify.success('ویرایش پست (Issue) با موفقیت انجام شد');

                        app.$parent.getIssues()

                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ویرایش پست (Issue) وجود ندارد');
                        }
                    );

            }
        },

        addIssueAttach(issueId){
            var app = this;

            // if(app.newIssue.fileLib_tags){
            //     if(app.newIssue.fileLib_tags.length !==0){
            //         app.newIssue.fileLib_tags = app.pluck(app.newIssue.fileLib_tags,"title")
            //     }
            // }

            if (app.newIssue.title.length > 100 || app.newIssue.description.length > 300){
                app.$snotify.error('تعداد حروف بیشتر از  کاراکتر مجاز است! متن رو کوتاه تر نمایید. ');
            }else {

                var newItem = app.newIssue;
                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }

                if(app.src != null)
                    formData.append("voice",app.src, "filename.wav");


                axios.post(`/api/intro/addAttach/`+issueId,  formData , app.auth)
                    .then(function (resp) {
                        // console.log(resp,"IssueCreate")
                        // app.items.push(app.timing);
                        app.$snotify.success('پیوست با موفقیت ثبت شد');
                        app.newIssue.title = ''
                        app.newIssue.intro = ''
                        app.newIssue.description = ''

                        app.newIssue.progress_input = ''

                        app.newIssue.voice = ''
                        app.newIssue.file = ''
                        app.newIssue.image = ''
                        app.newIssue.video = ''
                        app.newIssue.news = 0
                        app.newIssue.course_id = null
                        app.newIssue.course_category_id = null
                        app.newIssue.forum_id = null
                        app.newIssue.forum_category_id = null
                        app.newIssue.fileLib_tags = null
                        app.src = null
                        // app.newIssue.parent_id = null

                        // app.$parent.getIssues()

                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            console.log(e,"IssueCreate");
                            app.$snotify.error('امکان ثبت پست (Issue) وجود ندارد');
                        }
                    );
            }
        },

        deleteIssueAttach(attachId) {
            if (confirm("از حذف پیوست issue مطمئن هستید؟")) {
                var app = this;
                axios.get('/api/intro/deleteAttach/' + attachId, app.auth)
                    .then(function (resp) {
                        app.$snotify.success('حذف  پیوست issue با موفقیت انجام شد');
                        app.$parent.getIssues()
                    })
                    .catch(function (resp) {
                        app.$snotify.danger("امکان حذف وجود ندارد");
                    });
            }
        },

        getSubIssues(){
            var app = this;

            if (!app.issue.issues)
                app.issue.issues = []




            axios.get('/api/intro/getIssuesByParent/'+app.issue.id , app.auth)
                .then(res => {
                    app.issue.issues = res.data.data

                })
                .catch(error => {
                    console.log(error);
                })



        },

        returnIssueFields(fields, field_values , type_object){

            var combinedFieldAndValue = []
            if (field_values.length !== 0){
                if (type_object)
                    combinedFieldAndValue = _.map(field_values, function(item){
                        return _.extend(item, _.find(type_object.fields , { id: item.id, value: item.value }));
                    });
                else
                    combinedFieldAndValue = field_values
            }else {
                if (type_object)
                    combinedFieldAndValue = _.map(type_object.fields, function(item){
                        return _.extend(item, _.find(field_values , { id: item.id, value: item.value }));
                    });
                else
                    combinedFieldAndValue = []
            }


            combinedFieldAndValue.forEach(function (element) {
                if (!element.pivot.value)
                    element.pivot.value = '';
            });

            return combinedFieldAndValue
        },

        getTags(){
            var app = this;
            axios.get('/home/file/tagSearch/', app.auth)
                .then(function (response) {
                    app.fileCategories = response.data.data.tags.data

                    console.log(response.data.data.tags.data)


                    for (const key in app.fileCategories) {
                        if (app.fileCategories.hasOwnProperty(key)) {
                            const element = app.fileCategories[key];

                            app.options.push({
                                title: '#'+element.title,
                                id: element.id
                            })
                            // this.details[0].
                        }
                    }
                    // console.log(app.options)


                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },








        getProcesses(){
            var app = this;
            axios.get('/api/intro/processes', app.auth)
                .then(function (response) {
                    app.processes = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getSteps(processID = null){
            var app = this;
            axios.get('/api/intro/steps/'+processID ,  app.auth)
                .then(function (response) {
                    app.steps = response.data.data.data
                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        getOrders(){

            axios.get('/api/orders', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.orders = response.data.data;
                    console.log(response.data.data)
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false
                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },

        getContacts(){

            axios.get('/api/contacts', this.auth)
                .then(response => {
                    // this.current_page = response.data.current_page
                    this.contacts = response.data.data;
                    console.log(response.data.data)
                    // this.pagnationDate = response.data
                    // console.log(this.pagnationDate)
                    // this.loader = false

                    // this.makeContactOptions()

                })
                .catch(error => {
                    // this.loader = false
                    console.log(error);
                })
        },
        // makeContactOptions(){
        //     var app = this;
        //
        //     for (const key in app.contacts) {
        //         if (app.contacts.hasOwnProperty(key)) {
        //             const element = app.contacts[key];
        //
        //             app.contactOptions.push({
        //                 value: element.id,
        //                 text: element.first_name+' '+element.last_name
        //             })
        //             // this.details[0].
        //         }
        //     }
        //     console.log(app.contacts)
        //     console.log(app.contactOptions)
        //
        //
        // },
        getProjects() {
            axios
                .get('/api/projects', this.auth)
                .then(response => {
                    console.log('projects',response.data.data);

                    this.projects = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true
                })
        },






        getUsers(){
            var app = this;
            axios.get('/api/userslist', app.auth)
                .then(function (response) {
                    app.users = response.data

                    console.log('users',response.data)


                    for (const key in app.users) {
                        if (app.users.hasOwnProperty(key)) {
                            const element = app.users[key];

                            app.assignOptions.push({
                                name: '@'+element.name,
                                id: element.id
                            })
                        }
                    }

                    app.setAssignedUsers(app.issue.assigned_users)

                })
                .catch(function (e) {
                    console.log(e.response);
                });
        },

        setAssignedUsers(assigned_users){
            var app = this;
            // console.log('setAssignedUsers',assigned_users)
            // if (assigned_users.length !== 0)
            assigned_users.forEach(function (element) {
                // console.log('setAssignedUser',element.name,app.issue)
                // app.issue.users = []
                // app.issue.users.push({
                //     id: element.id,
                //     title: '@'+element.name
                // })
            });


        },


        stepStyle(stepId, issueStepId){
            if (stepId < issueStepId)
                return 'complete'
            if (stepId == issueStepId)
                return 'active'
            else
                return ''
        },


        prev() {
            this.$refs.carouselAttaches.prev()
            this.$refs.carouselAttachesM.prev()
        },
        next() {
            this.$refs.carouselAttaches.next()
            this.$refs.carouselAttachesM.next()
        },







        issueTypeText(issueType) {
            if (issueType.type == 1)
                return 'سرنخ (Lead)'
            else if (issueType.type == 2)
                return 'فرصت (Opportunity)'
            else if (issueType.type == 3)
                return 'ملاقات/جلسه/رویداد'
            else if (issueType.type == 4)
                return 'پیگیری (Ticket)'
            else if (issueType.type == 5)
                return 'ایراد (Bug)'
            else if (issueType.type == 6)
                return 'فعالیت (Task)'
            else if (issueType.type == 7)
                return 'لیست/شرح (Story)'
            else if (issueType.type == 8)
                return 'مجموعه/امکانات (Epic)'
            else if (issueType.type == 9)
                return 'پیام/تلفن (Message)'
            else if (issueType.type == 10)
                return 'گزارش/خبر (Report)'
            else if (issueType.type == 11)
                return 'سایر'
            else
                return 'سایر'
        },



    }



}
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }



</style>
